<template>
  <!-- 数据大屏 -->
   <transition name="why">
    <div class="big_view" v-show="!isMain">
    <div class="close_btn" @click="closeBig()"><el-icon style="color: #fff;font-size: 24px;"><DArrowRight /></el-icon></div>
   </div>
   </transition>

  <el-container class="layout-container-demo el-container">
      <el-aside width="80px" style="border-right: 1px solid #ebeef5;box-shadow: 0 1px 4px rgba(0,21,41,.08);z-index: 22;">
        <div class="home_logo"></div>
        <el-scrollbar style="height: calc(100% - 100px);font-size: 14px;">
          <el-menu class="first-menu-ul" active-text-color="#fff" :default-active="String(firstMenuActiveIndex)">
            <el-menu-item v-for="(item,index) in menuList" @click="changeFirstMenu(index)" :id="'first-menu-item-'+index" :key="index" :index="String(index)" style="padding-left: 10px;">
              <el-icon size="14"><component :is="item.icon" /></el-icon>
              {{item.name.substr(0,2)}}
            </el-menu-item>
          </el-menu>
        </el-scrollbar>
      </el-aside>
      <transition name="slide">
        <el-aside ref="aside" class="gsap-aside" width="200px" style="border-right: 1px solid #ebeef5;box-shadow: 0 1px 4px rgba(0,21,41,.08);z-index: 20;">
          <div class="aside_title">
            {{menuActiveName}}
          </div>
        <el-scrollbar style="height: calc(100% - 100px);">
          <el-menu ref="sideMenu" class="custom-menu" :default-active="getActiveMenuPath" :default-openeds="openSubMenuList" active-text-color="#2fc7a0">
            <!-- 一级菜单 -->
            <template v-for="(item,index) in secondMenuList">
                <el-menu-item v-if="item.children.length==0" @click="toPage(item)" :index="item.resource">
                  <!-- <el-icon><component :is="item.icon" /></el-icon> -->
                  {{item.name}}
                </el-menu-item>
                <el-sub-menu v-if="item.children.length>0" :index="String(index)">
                <template #title>
                  <!-- <el-icon><component :is="item.icon" /></el-icon>{{item.name}} -->
                  {{item.name}}
                </template>
                <!-- 二级菜单 -->
                <template v-for="(item2,index2) in item.children">
                  <el-menu-item v-if="item2.children.length==0" @click="toPage(item2)" :index="item2.resource">{{item2.name}}</el-menu-item>
                  <el-sub-menu v-if="item2.children.length>0" :index="'2-'+String(index2)" style="color: #fff;">
                    <template #title style="color: #fff;">
                      <!-- <el-icon><component :is="item2.icon" /></el-icon> -->
                      {{item2.name}}
                    </template>
                    <!-- 三级菜单 -->
                    <template v-for="(item3,index3) in item2.children">
                      <el-menu-item v-if="item3.children.length==0"  @click="toPage(item3)" :index="item3.resource">{{item3.name}}</el-menu-item>
                    </template>
                  </el-sub-menu>
                </template>
              </el-sub-menu>
            </template>
          </el-menu>
        </el-scrollbar>
      </el-aside>
    </transition>
      
    <div class="main">
    <el-container>
      <el-header style="text-align: right; font-size: 12px;height: 50px;color: #515a6e;">
      <div class="show_menu_btn" @click="toggleAside">
        <el-icon size="20" v-show="!isCollapsed"><Fold /></el-icon>
        <el-icon size="20" v-show="isCollapsed"><Expand /></el-icon>
      </div>  
      <div class="show_menu_url">
        <el-breadcrumb separator="/">
        <el-breadcrumb-item v-for="(item,index) in breadcrumbList" :key="index">{{item}}</el-breadcrumb-item>
      </el-breadcrumb>
      </div>
      <div class="toolbar">
        <el-icon style="font-size: 26px;margin-right: 8px;cursor: pointer;" @click="openBig()" title="可视化大屏"><TrendCharts /></el-icon>
          <el-dropdown>
            <el-icon style="margin-right: 8px; margin-top: 1px;cursor: pointer;">
              <setting />
            </el-icon>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item @click="loginOut()">退出登录</el-dropdown-item>
                <!-- <el-dropdown-item>Add</el-dropdown-item>
                <el-dropdown-item>Delete</el-dropdown-item> -->
              </el-dropdown-menu>
            </template>
          </el-dropdown>
          <span>{{userName}}</span>
        </div>
      </el-header>
      <el-main style="background-color: #f0f2f5;">
        <div class="routerPage">
          <!-- 切换页面 -->
          <HeaderTabs @openMenu="openMenuHandler"></HeaderTabs>
        </div>
      </el-main>
    </el-container>
  </div>
  </el-container>
</template>

<script setup>
import HeaderTabs from '@/components/HeaderTabs.vue'
import { gsap } from 'gsap';
</script>
<script>
import { ElMessage } from 'element-plus';
export default {
  name:'Home',
  data() {
    return {
      isCollapsed:false,
      isMain:true,
      userName:'',
      isCallMenu:false, //是否调用菜单
      menuList:[],  //菜单列表
      menuActiveName:'', //二级菜单头部
      breadcrumbList:[], //面包屑列表
      secondMenuList:[],  //二级菜单列表
      firstMenuActiveIndex: 0, //一级菜单激活索引
      openSubMenuList: [], //展开的子菜单索引列表
    }
  },
  computed: {
    // 计算当前激活的菜单项路径
    getActiveMenuPath() {
      return this.$route.path;
    }
  },
  beforeCreate(){
    
  },
  created(){
    //更新菜单
    this.$store.state.authority = JSON.parse(localStorage.getItem('authority'));
    // console.log(localStorage.getItem('authority'));
    var roleMenu = this.$store.state.authority;
    this.menuList = roleMenu;
    this.getStationList();
  },
  mounted(){
    this.userName = localStorage.getItem('SAAS_USERNAME')?localStorage.getItem('SAAS_USERNAME'):'Mine';
    this.restoreMenuFromRoute();
  },
  methods:{
    // openMenuHandler() {
    //   // 在这里编写打开菜单的逻辑
    //   const aside = this.$refs.aside.$el;
    //   const main = document.querySelector('.main'); // 获取 main 元素
    //   const asideWidth = aside.offsetWidth;

    //   if (this.isCollapsed) {
    //     gsap.to(aside, { 
    //       x: 0, 
    //       duration: 0.3,
    //       ease: "power2.out"
    //     });
    //     // 展开侧边栏时设置 main 元素的 margin-left
    //     main.style.width = `calc(100% - 280px)`;
    //     main.style.marginLeft = `${asideWidth}px`; 
    //   }
      
    //   this.isCollapsed = false;
    // },
    openMenuHandler(url) {
      // 展开侧边栏
      const aside = this.$refs.aside.$el;
      const main = document.querySelector('.main'); 
      const asideWidth = aside.offsetWidth;

      if (this.isCollapsed) {
        gsap.to(aside, { 
          x: 0, 
          duration: 0.3,
          ease: "power2.out"
        });
        main.style.width = `calc(100% - 280px)`;
        main.style.marginLeft = `${asideWidth}px`; 
      }
      this.isCollapsed = false;

      // 找到对应菜单项
      let targetMenuItem = null;
      // 存储对应菜单项的一级菜单索引
      let firstMenuIndex = -1; 

      this.menuList.some((menuItem, index) => {
        if (menuItem.resource === url) {
          targetMenuItem = menuItem;
          firstMenuIndex = index;
          return true;
        }
        if (menuItem.children) {
          return menuItem.children.some((subMenuItem) => {
            if (subMenuItem.resource === url) {
              targetMenuItem = subMenuItem;
              firstMenuIndex = index;
              return true;
            }
            if (subMenuItem.children) {
              return subMenuItem.children.some((grandSubMenuItem) => {
                if (grandSubMenuItem.resource === url) {
                  targetMenuItem = grandSubMenuItem;
                  firstMenuIndex = index;
                  return true;
                }
                return false;
              });
            }
            return false;
          });
        }
        return false;
      });

      // 如果找到目标菜单项
      if (targetMenuItem && firstMenuIndex !== -1) {
        // 切换一级菜单
        // this.changeFirstMenu(firstMenuIndex);
        //触发一级菜单切换事件
        this.isCallMenu = true; //调用一级菜单
        document.getElementById('first-menu-item-'+firstMenuIndex).click();

        // 清空面包屑列表
        this.breadcrumbList = [];
        // 查找当前菜单项的完整路径
        let currentItem = targetMenuItem;
        const path = [];
        while (currentItem) {
          path.unshift(currentItem.name);
          // 假设父菜单通过 parent 属性关联，根据实际情况调整
          currentItem = this.findParentMenuItem(currentItem); 
        }
        // 给面包屑列表赋值
        this.breadcrumbList = path;
      }
    },
    setDefaultMenu(){
      this.changeFirstMenu(0);
      this.menuActiveName = this.menuList[0].name;
    },
    restoreMenuFromRoute(){
      //根据当前路由恢复菜单状态
      let currentPath = this.$route.path;
      let targetMenuItem = null;
      let firstMenuIndex = 0;
      
      //查找当前路由对应的菜单项
      this.menuList.some((menuItem, index) => {
        if (menuItem.resource === currentPath) {
          targetMenuItem = menuItem;
          firstMenuIndex = index;
          return true;
        }
        if (menuItem.children) {
          return menuItem.children.some((subMenuItem) => {
            if (subMenuItem.resource === currentPath) {
              targetMenuItem = subMenuItem;
              firstMenuIndex = index;
              return true;
            }
            if (subMenuItem.children) {
              return subMenuItem.children.some((grandSubMenuItem) => {
                if (grandSubMenuItem.resource === currentPath) {
                  targetMenuItem = grandSubMenuItem;
                  firstMenuIndex = index;
                  return true;
                }
                return false;
              });
            }
            return false;
          });
        }
        return false;
      });
      
      if (targetMenuItem && firstMenuIndex !== -1) {
        //找到对应菜单，恢复状态
        this.breadcrumbList = [];
        this.secondMenuList = [];
        this.menuActiveName = this.menuList[firstMenuIndex].name;
        this.firstMenuActiveIndex = firstMenuIndex;
        
        //设置二级菜单列表
        if(this.menuList[firstMenuIndex].children.length > 0){
          this.secondMenuList = this.menuList[firstMenuIndex].children;
        } else {
          this.secondMenuList.push(this.menuList[firstMenuIndex]);
        }
        
        //设置面包屑
        let currentItem = targetMenuItem;
        const path = [];
        while (currentItem) {
          path.unshift(currentItem.name);
          currentItem = this.findParentMenuItem(currentItem);
        }
        this.breadcrumbList = path;
      } else {
        //未找到对应菜单，使用默认
        this.setDefaultMenu();
      }
    },
    changeFirstMenu(index){
      this.firstMenuActiveIndex = index;
      this.breadcrumbList = [];
      this.secondMenuList = [];
      this.menuActiveName = this.menuList[index].name;
      if(this.menuList[index].children.length>0){
        this.secondMenuList = this.menuList[index].children;
      }else{
        this.secondMenuList.push(this.menuList[index]);
      }
      if(this.isCallMenu){
        this.isCallMenu = false;
      }else{
        // 获取第一个可跳转的菜单项
        const firstNavigableMenu = this.getFirstNavigableMenu(this.secondMenuList[0]);
        // 如果第一个二级菜单有三级菜单，展开它
        if(this.secondMenuList[0].children && this.secondMenuList[0].children.length > 0){
          this.openSubMenuList = ['0'];
          // 使用 nextTick 确保 DOM 更新后再展开
          this.$nextTick(() => {
            if (this.$refs.sideMenu) {
              this.$refs.sideMenu.open('0');
            }
          });
        } else {
          this.openSubMenuList = [];
        }
        this.toPage(firstNavigableMenu);
      }
    },
    // 递归查找第一个可跳转的菜单项（没有子菜单的菜单项）
    getFirstNavigableMenu(menuItem) {
      if (!menuItem.children || menuItem.children.length === 0) {
        return menuItem;
      }
      // 如果有子菜单，递归查找第一个可跳转的子菜单
      return this.getFirstNavigableMenu(menuItem.children[0]);
    },
    toggleAside() {
      const aside = this.$refs.aside.$el;
      const main = document.querySelector('.main'); // 获取 main 元素
      const asideWidth = aside.offsetWidth;

      if (this.isCollapsed) {
        gsap.to(aside, { 
          x: 0, 
          duration: 0.3,
          ease: "power2.out"
        });
        // 展开侧边栏时设置 main 元素的 margin-left
        main.style.width = `calc(100% - 280px)`;
        main.style.marginLeft = `${asideWidth}px`; 
      } else {
        gsap.to(aside, { 
          x: -asideWidth, 
          duration: 0.3,
          ease: "power2.in"
        });
        // 收起侧边栏时设置 main 元素的 margin-left
        main.style.width = 'calc(100% - 80px)';
        main.style.marginLeft = '0px'; 
      }
      
      this.isCollapsed = !this.isCollapsed;
    },
    getStationList(){
      //获取场站列表
      let that = this;
      that.$axios.post("platform-server/station/list",{}).then(result => {
        // console.log(result);
        if(result.code==200){
          this.$store.state.stationList = result.data;}
        })
    },
    closeBig(){
      this.isMain = true;
    },
    openBig(){
      // 在新标签页打开/largescreen页面
      const routeUrl = this.$router.resolve({ path: '/largescreen' });
      window.open(routeUrl.href, '_blank');
    },
    toPage(item){
      // this.$router.push(url);
      // 将当前点击的对象传递给指定方法
      let row = {};
      row.topic = item.name;
      row.path = item.resource;

      this.$store.commit("addHeaderTabs",row)
      
      // 清空面包屑列表
      this.breadcrumbList = [];
      // 查找当前菜单项的完整路径
      let currentItem = item;
        const path = [];
        while (currentItem) {
          path.unshift(currentItem.name);
          // 假设父菜单通过 parent 属性关联，根据实际情况调整
          currentItem = this.findParentMenuItem(currentItem); 
        }

        // 给面包屑列表赋值
        this.breadcrumbList = path;

      // 如果是三级菜单，展开对应的二级菜单
      this.openSubMenuList = [];
      const subMenuIndex = this.findParentSubMenuIndex(item);
      if (subMenuIndex !== null) {
        this.openSubMenuList = [String(subMenuIndex)];
        // 使用 nextTick 确保 DOM 更新后再展开
        this.$nextTick(() => {
          if (this.$refs.sideMenu) {
            this.$refs.sideMenu.open(String(subMenuIndex));
          }
        });
      }

      // 跳转相关路由
      this.$router.push({
          path:item.resource
      })
    },
    // 查找父级二级菜单的索引
    findParentSubMenuIndex(item) {
      // 遍历当前二级菜单列表查找
      for (let j = 0; j < this.secondMenuList.length; j++) {
        const secondMenu = this.secondMenuList[j];
        // 如果二级菜单有子菜单（三级菜单）
        if (secondMenu.children && secondMenu.children.length > 0) {
          // 遍历三级菜单查找
          for (let k = 0; k < secondMenu.children.length; k++) {
            const thirdMenu = secondMenu.children[k];
            if (thirdMenu === item || thirdMenu.resource === item.resource) {
              // 找到对应的三级菜单，返回其父级二级菜单的索引
              return j;
            }
          }
        }
      }
      return null;
    },
    // 查找父菜单项的方法
    findParentMenuItem(item) {
        // 遍历菜单列表查找父菜单项，根据实际菜单结构调整
        for (const menu of this.menuList) {
          if (menu.children) {
            for (const child of menu.children) {
              if (child === item) {
                return menu;
              }
              if (child.children) {
                for (const grandChild of child.children) {
                  if (grandChild === item) {
                    return child;
                  }
                }
              }
            }
          }
        }
        return null;
      },
    loginOut(){
      //退出登录
      let param = {}
      this.$axios.post("gateway/logout",param).then(result => {
        if(result.code==200){
          this.$router.push('/');
          this.$store.state.token = '';
          this.$store.state.HeaderTabs = [];
          this.$store.state.TabsActiveName = '';
          localStorage.removeItem('HeaderTabs');
          localStorage.removeItem('TabsActiveName');
        }
      })
    }
  },
  components: {
    
  }
}
</script>

<style lang="scss">
.big_view{
  width: 100%;
  height: 100vh;
  position: fixed;
  z-index: 99;
  top: 0;
  left: 0;
  background: url('../assets/images/index.png') no-repeat;
  background-size: cover;
  .close_btn{
    width: 50px;
    height: 50px;
    border-radius: 100%;
    border: 1px solid #fff;
    position: absolute;
    top: 10px;
    right: 20px;
    cursor: pointer;
    .el-icon{
      position: absolute;
      margin: auto;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
    }
  }
}
.el-container{
  height: 100vh;
}
.layout-container-demo .el-header {
  position: relative;
  // background-color: #282c34;
  // background: linear-gradient(90deg,#1d42ab,#2173dc,#1e93ff);
  // color: #fff;
}
.layout-container-demo .el-aside {
  background-color: #fff;
  // background-color: #545c64;
  // color: #fff;
}
.layout-container-demo .el-menu {
  border-right: none;
}
.layout-container-demo .el-main {
  padding: 0;
}
.layout-container-demo .toolbar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  right: 20px;
}
.show_menu_btn{
  width: 50px;
  height: 50px;
  position: absolute;
  margin: auto;
  left: 0px;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  // background: url('../assets/images/logo.png') no-repeat;
  // background-size: cover;
}
.show_menu_url{
  width: 100%;
  height: 50px;
  // line-height: 50px;
  font-size: 16px;
  color: #515a6e;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  position: absolute;
  margin: auto;
  left: 60px;
  top: 0;
  bottom: 0;
}
// .layout-container-demo .el-menu{
//   // background-color: #495867; /* 背景色 */
//   // background-color: #fff;
// }
// ::v-deep .el-menu--horizontal {
//   .is-active {
//     background-color: #409EFF; /* 修改为你想要的颜色 */
//     color: #fff; /* 修改为你想要的文字颜色 */
//   }
// }
// .el-menu-item .is-active {
//   background-color: #409EFF;
// }
/* 更改文字颜色 */
// .custom-menu .el-menu-item,
// .custom-menu .el-submenu__title {
//   // color: #fff;
// }
// /* 设置一级菜单和二级菜单的背景颜色 */
// .el-sub-menu .el-menu-item {
//   // color: #fff !important;
// }
// .el-sub-menu .el-sub-menu__title{
//   // color: #fff !important;
// }
.el-sub-menu__title:hover{
  // background-color: #2173dc !important;
  // color: #fff;
  color: #2173dc;
}
.el-menu-item:hover{
  // background-color: #2173dc !important;
  // color: #fff;
  color: #2173dc;
}
.first-menu-ul .el-menu-item.is-active {  
  color: #fff !important;  
  background: #409eff !important;  
} 
.custom-menu .el-menu-item.is-active {  
  color: #fff !important;  
  background: #409eff !important;  
} 
.first-menu-ul,
.custom-menu {
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
} 
.routerPage {
		// padding: 12px;
		overflow: auto;
		box-sizing: border-box;
		height: calc(100% - 40px);
	}

.home_logo{
  width: 60px;
  height: 60px;
  margin: 20px auto;
  display: flex;
  align-items: center;
  justify-content: center;
  background: url('../assets/images/logo_yc.png') no-repeat;
  background-size: 100% 100%;
}
.layout-container-demo {
  position: relative; // 父容器设置相对定位，作为绝对定位的参考
}
.aside_title{
  height: 50px;
  // line-height: 50px;
  font-size: 16px;
  // color: #515a6e;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #ebeef5;
}
.gsap-aside {
  position: absolute;
  top: 0;
  left: 80px;
  height: 100%;
}

.main {
  width: calc(100% - 280px);
  margin-left: 200px;
  flex: 1;
  transition: margin-left 0.5s ease;
}

.first-menu-select{
  background: #409eff !important;  
  color: #fff;
}

.second-menu-select{
  background: #409eff !important;  
  color: #fff;
}

// // 一级菜单选中样式
// .layout-container-demo .custom-menu > .el-menu-item.is-active {
//   color: #fff !important;
//   background-color: #409EFF !important;
// }

// // 二级菜单选中样式
// .layout-container-demo .custom-menu .el-sub-menu .el-menu-item.is-active {
//   color: #fff !important;
//   background-color: #2fc7a0 !important;
// }

// // 三级菜单选中样式
// .layout-container-demo .custom-menu .el-sub-menu .el-sub-menu .el-menu-item.is-active {
//   color: #fff !important;
//   background-color: #ff9900 !important;
// }

// // 子菜单展开时标题样式
// .layout-container-demo .custom-menu .el-sub-menu.is-opened .el-sub-menu__title {
//   color: #2173dc !important;
//   background-color: #f0f2f5 !important;
// }
</style>